import { render, staticRenderFns } from "./ReportPurchasesByCategoryDetail.vue?vue&type=template&id=33c7b22c&"
import script from "./ReportPurchasesByCategoryDetail.vue?vue&type=script&lang=js&"
export * from "./ReportPurchasesByCategoryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports